import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelector } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";
import { CodPostal } from "app/features/componentes/codpostal";

type Entity = models.ZonaExtendidaCP;
export interface Props extends kea.ModalProps<Entity, boolean, undefined> {
}

/**
 * Valida un ZonaExtendidaCP
 */
export function validar(x: Entity) {
    const rules: validation.Rules<Entity> = {
        CP: validation.required
    };
    return validation.getErrors(rules, x);
}

/**
* Modal de edición para un ZonaExtendidaCP
*/
export class ZonaExtendidaCPEdit extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    errors = createSelector(this.value, x => validar(x));
    hasError = createSelector(this.errors, x => validation.hasError(x));
    getField = formfields(() => this.props, () => this.errors(this.props));

    onGuardar = () => {
        this.props.onClose(true);
    };

    onCerrar = () => {
        this.props.onClose(false);
    }
    render() {
        const value = this.props.value;
        const getField = this.getField;
        const hasError = this.hasError(this.props);

        const Number = getField(CodPostal);

        return (
            <kea.Modal
                buttons={[<kea.GuardarButton onClick={this.onGuardar} disabled={hasError} />]}
                onClose={this.onCerrar}
                title="Editar CP"
            >

                {kea.autogrid(3, [
                    <Number field="CP" />
                ])}
            </kea.Modal>
        )
    }
}



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/zonaextendida/edit/cps/edit.tsx